/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_All_StaffInputs */

const vi_station_work_all_staff = /** @type {(inputs: Station_Work_All_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn thể nhân viên`)
};

/**

* @param {Station_Work_All_StaffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_all_staff = /** @type {((inputs?: Station_Work_All_StaffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_All_StaffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_all_staff(inputs)
});